import { ADMIN_API_METHOD_TYPES, type AdminCaptureAppErrorRequest } from '@sdk/api/modules/admin/types.admin'
import { usePostRobot } from '@lib/sdk/utils/postrobot'

/**
 * Send an app error to Pitcher sentry instance.
 *
 * @example
 * try {
 *   throw new Error('This is an error')
 * } catch (error) {
 *   useAdmin().captureAppError({
 *     error,
 *     message: 'This is an app error',
 *   })
 * }
 *
 * @param payload error object to send to Pitcher sentry instance
 */
export async function captureAppError(payload: AdminCaptureAppErrorRequest): Promise<void> {
  const pr = await usePostRobot()
  pr.send(window.parent, ADMIN_API_METHOD_TYPES.CAPTURE_APP_ERROR, payload)
}
